import React from 'react';
import { ThemeProvider } from 'styled-components';

// import { SchedulerItem } from '@einstein/schedule-platform';
import Home from './pages/Home';
import theme from './styles/theme';

function App() {
  // const [visible, setVisible]  = React.useState(false)
  return (
    <ThemeProvider theme={theme}>
      <Home/>
    </ThemeProvider>
  );
}

export default App;
